import React, { Fragment, useRef, useState } from "react"
import { connect, useSelector } from "react-redux"
import { login } from "../../actions/authentication"
import { openSnackBar } from "actions/snack-bar"
import { withStyles } from "@material-ui/styles"
import styles from "./styles"
import Header from "components/Header"
import SplitBottomNav from "components/SplitBottomNav"
import {
  Container,
  Button,
  Typography,
  InputAdornment,
  CircularProgress,
  Box
} from "@material-ui/core"
import { Formik, Form } from "formik"
import { useHistory, Link } from "react-router-dom"
import MaskedMobileInput from "../../components/MaskedMobileInput"
import * as Yup from "yup"
import ReusableFormControl from "../../components/ReusableFormControl"
import { openResetPasswordDialog } from "actions/reset-password-dialog"
import packageTest from "../../../package.json"
import { useEffect } from "react"
import LoaderButton from "../../components/LoaderButton"
import { getLogo } from "actions/organization"

const LoginSchema = Yup.object().shape({
  mobile: Yup.string()
    .required("Required")
    .length(14, "Please enter a mobile phone number"),
  password: Yup.string().required("Required")
})

const Login = (props, token) => {
  const { classes, dispatch } = props
  const [logo, setLogo] = useState()
  const [orgName, setOrgName] = useState()
  const [isWhiteLabeled, setIsWhiteLabeled] = useState(false)
  const [logoLoading, setLogoLoading] = useState(false)
  const formRef = useRef()
  let history = useHistory()
  const authentication = useSelector(state => state.authentication)
  const [isLoading, setIsLoading] = useState(false)

  // const qParams = new queryString.parse(window.location.search)
  const urlParams = new URLSearchParams(window.location.search)
  const skipOrg = urlParams.get("skipOrg")

  const creatingOrg = skipOrg === "true"

  const handleSignUp = () => {
    if (creatingOrg) {
      history.push("/register?skipOrg=true")
    } else {
      history.push("/register")
    }
  }

  const handleSubmit = e => {
    e.preventDefault()
    if (formRef.current) {
      formRef.current.handleSubmit()
    }
  }

  const handleOpenResetPassword = () => {
    dispatch(openResetPasswordDialog())
  }

  useEffect(() => {
    if (creatingOrg) {
      dispatch(
        openSnackBar({
          message: "Please login before creating an organization"
        })
      )
    }
  }, [creatingOrg])

  useEffect(() => {
    setLogoLoading(true)
    dispatch(getLogo({ subdomain: window.location.host.split(".")[0] }))
      .then(res => {
        if (res.logo !== null) {
          setLogo(JSON.parse(res.logo).secure_url)
        } else {
          setLogo(res.logo)
        }
        setOrgName(res.name)
        setIsWhiteLabeled(res.white_labeled)
      })
      .catch(err => {
        console.log(err)
      })
      .finally(() => {
        setLogoLoading(false)
      })
  }, [])

  useEffect(() => {
    if (
      authentication &&
      authentication.authenticatedUser &&
      authentication.authenticatedUser.user_orgs
    ) {
      if (authentication.authenticatedUser.user_orgs.length > 0) {
        const parts = window.location.host.split(".")
        let org = null
        if (parts.length === 3) {
          org = authentication.authenticatedUser.user_orgs.find(
            x => x.subdomain === parts[0]
          )
          parts.shift()
        } else {
          org = authentication.authenticatedUser.user_orgs[0]
        }
        if (org) {
          window.location.href = `${window.location.protocol}//${org.subdomain}.${parts[0]}.${parts[1]}/app/feed`
        }
      }
    }
  }, [authentication])

  return (
    <Fragment>
      <div className={classes.page}>
        <Header
          whiteLabeledLogo={logo}
          isWhiteLabeled={isWhiteLabeled}
          logoLoading={logoLoading}
          orgName={orgName}
        />
        <Container className={classes.formContainer}>
          <Box
            display="flex"
            flexDirection="column"
            justifyContent="flex-end"
            flex="3"
          >
            <Typography className={classes.loginTitle} variant="h2">
              Login
            </Typography>
            {/* <Typography className={classes.loginTitle}>
            Lorem ipsum dolor sit amet consectetur adipisicing elit.
          </Typography> */}
            <Formik
              innerRef={formRef}
              initialValues={{ mobile: "", password: "" }}
              onSubmit={(values, { setSubmitting }) => {
                setIsLoading(true)

                props
                  .dispatch(
                    login({
                      phone: values.mobile,
                      password: values.password
                    })
                  )
                  .then(res => {
                    if (creatingOrg) {
                      return (window.location.href = `/signup?token=${res.token}&user=${res.id}`)
                    }
                    try {
                      const host = window.location.host.split(".")
                      const subdomain = res.user_orgs[0].subdomain
                      const subMatches = res.user_orgs.filter(org => {
                        return host[0] === org.subdomain
                      })
                      // setTimeout(() => {
                      if (host.length === 3 && subMatches.length) {
                        history.push("/app/feed")
                      } else if (host.length === 3) {
                        window.location = `http://${subdomain}.${host[1]}.${host[2]}/app/feed?token=${res.token}&user=${res.id}`
                      } else {
                        window.location = `http://${subdomain}.${host[0]}.${host[1]}/app/feed?token=${res.token}&user=${res.id}`
                      }
                      // }, 2000)
                    } catch (err) {
                      console.log(err)
                      dispatch(
                        openSnackBar({
                          message:
                            "This account is not associated with any organizations"
                        })
                      )
                      history.push("/noorganizationpage")
                    }
                  })
                  .catch(err => {
                    props.dispatch(
                      openSnackBar({
                        message: "Invalid mobile number and password."
                      })
                    )
                    return
                  })
                  .finally(() => setIsLoading(false))
              }}
              validationSchema={LoginSchema}
            >
              {formikProps => (
                <Form
                  className={classes.form}
                  onKeyPress={e => {
                    if (e.key === "Enter") {
                      handleSubmit(e)
                    }
                  }}
                  onSubmit={handleSubmit}
                >
                  <ReusableFormControl
                    name="mobile"
                    label="Mobile"
                    formikProps={formikProps}
                    inputProps={{
                      inputComponent: MaskedMobileInput,
                      classes: {
                        input: classes.white
                      },
                      className: classes.mobileInput
                    }}
                    inputLabelClass={classes.white}
                  />

                  <ReusableFormControl
                    name="password"
                    label="Password"
                    formikProps={formikProps}
                    inputProps={{
                      className: classes.passwordInput,
                      endAdornment: (
                        <InputAdornment
                          className={classes.forgotPassword}
                          position="end"
                        >
                          <Link to="" onClick={handleOpenResetPassword}>
                            <Typography className={classes.forgotPasswordPhone}>
                              Forgot Password?
                            </Typography>
                          </Link>
                        </InputAdornment>
                      ),
                      classes: {
                        input: classes.white
                      },
                      type: "password"
                    }}
                    inputLabelClass={classes.white}
                  />
                  {window.innerWidth > 1280 ? (
                    <LoaderButton
                      type="submit"
                      working={isLoading}
                      classes={{
                        button: classes.loginButton,

                        buttonProgress: classes.buttonProgress
                      }}
                    >
                      Login
                    </LoaderButton>
                  ) : null}
                </Form>
              )}
            </Formik>
          </Box>
          <Box
            display="flex"
            flexDirection="column"
            justifyContent="center"
            flex="auto"
          >
            <Typography className={classes.formRegister} variant="body2">
              <Link to={`/register${creatingOrg ? "?skipOrg=true" : ""}`}>
                Join an organization
              </Link>
            </Typography>
            <Typography className={classes.formRegister} variant="body2">
              <Link to={`/signup`}>Create an organization</Link>
            </Typography>
            <Typography className={classes.version}>
              {packageTest.version}
            </Typography>
          </Box>
        </Container>
        {window.innerWidth < 1280 ? (
          <SplitBottomNav>
            <Button color="primary" onClick={handleSignUp}>
              <span>Don't have an account?</span>
              Sign Up
            </Button>
            <Button onClick={handleSubmit}>
              {isLoading ? (
                <CircularProgress
                  sytle={{ width: "24px" }}
                  classes={{ colorPrimary: classes.spinnerColor }}
                />
              ) : (
                "sign in >"
              )}
            </Button>
          </SplitBottomNav>
        ) : null}
        {/* {isLoading && <Loading />} */}
      </div>
    </Fragment>
  )
}

const mapStateToProps = state => {
  return {
    profile: state.profile,
    token: state.authentication.token
  }
}

const connector = connect(mapStateToProps)

export default withStyles(styles)(connector(Login))



// WEBPACK FOOTER //
// ./src/pages/Login/index.js